module.exports = __webpack_public_path__ + "img/stivenknig.bf122eb8.jpeg";